export default "__VITE_ASSET__C9KNo5jg__"